import { LAYOUT_MAX_STAGE_PIXELS } from '../../constants';

// The rendered stage must never exceed the browser canvas limits — an oversized
// allocation kills the whole canvas (the crashed sad-face tab).
export const capScaleToStageLimit = (scale: number, size: number): number =>
  size > 0 ? Math.min(scale, LAYOUT_MAX_STAGE_PIXELS / size) : scale;
